import { MultiSelectChangeEvent } from 'primereact/multiselect';

import { InputComponent } from '../../../components/InputComponent';
import { MultiSelectComponent } from '../../../components/MultiSelectComponent';
import { RadioButtonComponent } from '../../../components/RadioButtonComponent';
import { IReassigmentProvider } from '../../../interfaces/service/ReassignmentServiceManagerInterface';
import { deviceDataTableColumns, samDataTableColumns } from '../utils';

interface IFiltersComponent {
  serviceReassignment: IReassigmentProvider;
}

export const Filters = (props: IFiltersComponent) => {
  const { serviceReassignment } = props;

  const renderRadioButtonSam = () => {
    return (
      <div className="w-1/4">
        <RadioButtonComponent
          inputId="SAM"
          name="SAM"
          label="SAM"
          value="SAM"
          checked={serviceReassignment.radioSelection === 'SAM'}
          changeHandler={serviceReassignment.onRadioChange}
        />
      </div>
    );
  };

  const renderRadioButtonEquipment = () => {
    return (
      <div className="w-1/4">
        <RadioButtonComponent
          inputId="Device"
          name="Device"
          label="Equipo"
          value="Device"
          checked={serviceReassignment.radioSelection === 'Device'}
          changeHandler={serviceReassignment.onRadioChange}
        />
      </div>
    );
  };

  const renderFindSearch = () => {
    return (
      <div className="felx min-w-[200px] max-w-[400px] mx-1 justify-end">
        <InputComponent
          type={'text'}
          name={'find'}
          value={serviceReassignment.filterSamId}
          className=" h-[30px] !placeholder-black"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            serviceReassignment.onSamIdChange(e.target.value);
          }}
          placeholder="Filtrar por SAM ID"
          classSpan={'p-input-icon-right h-[30px]'}
        />
      </div>
    );
  };

  const renderSelectDevices = () => {
    return (
      <div className="flex min-w-[200px] max-w-[400px] justify-end h-[30px]">
        <MultiSelectComponent
          id="deviceType"
          name="deviceType"
          options={serviceReassignment.filterData.deviceTypeData}
          optionLabel={'name'}
          placeholder="Tipo Equipo"
          value={serviceReassignment.deviceTypeSelected}
          className=" h-[30px]"
          onChange={(e: MultiSelectChangeEvent) =>
            serviceReassignment.onDeviceTypeChange(e)
          }
          max={0}
          selectedItemsLabel="Seleccionado"
        />
      </div>
    );
  };

  const renderSelectSamType = () => {
    return (
      <div className="flex min-w-[200px] max-w-[400px] mx-1 justify-end h-[30px]">
        <MultiSelectComponent
          options={serviceReassignment.filterData.samTypesData}
          optionLabel={'name'}
          placeholder="Tipo SAM"
          value={serviceReassignment.samTypeSelected}
          className=" h-[30px]"
          onChange={(e: MultiSelectChangeEvent) =>
            serviceReassignment.onSamTypeChange(e)
          }
          max={0}
          selectedItemsLabel="Seleccionado"
        />
      </div>
    );
  };

  const renderSelectColumn = () => {
    return (
      <div className="min-w-[200px] max-w-[400px] mx-1">
        <MultiSelectComponent
          options={
            serviceReassignment.radioSelection === 'SAM'
              ? samDataTableColumns
              : deviceDataTableColumns
          }
          optionLabel={'header'}
          placeholder="Seleccionar columnas"
          value={serviceReassignment.columnsSelected}
          className=" h-[30px]"
          onChange={serviceReassignment.handleSelectColumn}
          selectedItemsLabel="Seleccionar columnas"
        />
      </div>
    );
  };

  function samFilters() {
    return (
      <>
        {renderSelectSamType()}
        {renderFindSearch()}
      </>
    );
  }

  return (
    <>
      <div className="w-full h-[48px] flex mx-5">
        <div className="flex w-full h-full">
          <div className="flex h-full w-1/4 items-center">
            {renderRadioButtonSam()}
            {renderRadioButtonEquipment()}
          </div>
          <div className="flex h-full w-3/4 items-center justify-end">
            {serviceReassignment.radioSelection === 'SAM'
              ? samFilters()
              : renderSelectDevices()}
            {renderSelectColumn()}
          </div>
        </div>
      </div>
    </>
  );
};
